<div class="news" [ngClass]="{'left-image-display': displayImageOnLeft}">
    <a [routerLink]="['/hir', news.slug]" [title]="news.title" class="image-holder" *ngIf="displayImage && news.imageUrl !== null">
        <img [src]="getImageSize(news.imageUrl)" [title]="news.title" [alt]="news.title" />
    </a>
    <div class="data-holder">
        <a class="title" [routerLink]="['/hir', news.slug]" [title]="news.title" [ngClass]="titleSize" [ngStyle]="titleStyle !== null && {'color': titleStyle.color, 'background-color': titleStyle.backgroundColor}">{{news.title}}</a>
        <div class="subtitle" *ngIf="displaySubtitle">{{news.subTitle}}</div>
    </div>
</div>